import { Volume2, VolumeX, Play, Pause } from 'lucide-react'
const VideoControls = ({
    showControls,
    handleSeek,
    duration,
    isMuted,
    handleVolumeChange,
    volume,
    handleMuteToggle,
    currentTime,
    handlePlayPause,
    isPlaying,
}) => {
    return (
        <>
            <div
                className="tw:absolute tw:inset-0 tw:flex tw:items-center tw:justify-center tw:pointer-events-none"
                style={{
                    background: !isPlaying ? 'rgba(0, 0, 0, 0.3)' : 'transparent',
                    transition: 'background 0.2s ease',
                    zIndex: 500,
                }}
            >
                <button
                    onClick={handlePlayPause}
                    className="tw:pointer-events-auto tw:bg-transparent tw:rounded-full tw:p-6 tw:transition-all tw:duration-200 hover:tw:scale-110"
                    style={{
                        opacity: showControls ? 1 : 0,
                        transform: showControls ? 'scale(1)' : 'scale(0.8)',
                        transition: 'opacity 0.2s ease, transform 0.2s ease',
                    }}
                >
                    {isPlaying ? (
                        <Pause className="tw:h-12 tw:w-12 tw:text-white" />
                    ) : (
                        <Play className="tw:h-12 tw:w-12 tw:text-white tw:ml-1" />
                    )}
                </button>
            </div>
            <div
                className="tw:absolute tw:bottom-0 tw:left-0 tw:right-0 tw:px-4 tw:py-3 tw:pointer-events-none"
                style={{
                    background: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 100%)',
                    bottom: '1px',
                    opacity: showControls ? 1 : 0,
                    transition: 'opacity 0.3s ease',
                    zIndex: 500,
                }}
            >
                {/* Progress bar */}
                <div
                    className="tw:relative tw:h-1 tw:bg-white tw:bg-opacity-30 tw:rounded-full tw:cursor-pointer tw:pointer-events-auto"
                    onClick={handleSeek}
                    style={{
                        minHeight: '4px',
                        backgroundColor: 'rgba(255, 255, 255, 0.3)',
                    }}
                >
                    <div
                        className="tw:absolute tw:h-full tw:bg-white tw:rounded-full"
                        style={{
                            left: 0,
                            top: 0,
                            width: `${(currentTime / duration) * 100 || 0}%`,
                            transition: 'width 0.2s ease-out',
                        }}
                    />
                    <div
                        className="tw:absolute tw:w-3 tw:h-3 tw:bg-white tw:rounded-full tw:shadow-md"
                        style={{
                            left: `${(currentTime / duration) * 100 || 0}%`,
                            top: '50%',
                            transform: 'translateX(-50%) translateY(-50%)',
                            transition: 'left 0.2s ease-out',
                        }}
                    />
                </div>
            </div>

            {/* Vertical volume controls on the bottom right edge */}
            <div
                className="tw:absolute tw:flex tw:flex-col tw:items-center tw:gap-2 tw:pointer-events-none"
                style={{
                    right: '-20px',
                    bottom: '30px',
                    opacity: showControls ? 1 : 0,
                    transition: 'opacity 0.3s ease',
                    zIndex: 500,
                }}
            >
                <div className="tw:relative tw:h-20 tw:flex tw:items-center tw:justify-center">
                    <input
                        type="range"
                        min="0"
                        max="1"
                        step="0.1"
                        value={isMuted ? 0 : volume}
                        onChange={handleVolumeChange}
                        className="tw:w-20 tw:h-1 tw:bg-white tw:bg-opacity-30 tw:rounded-full tw:appearance-none tw:cursor-pointer tw:pointer-events-auto"
                        style={{
                            transform: 'rotate(-90deg)',
                            transformOrigin: 'center',
                            background: `linear-gradient(to right, white ${(isMuted ? 0 : volume) * 100}%, rgba(255,255,255,0.3) ${(isMuted ? 0 : volume) * 100}%)`,
                        }}
                    />
                </div>
                <button
                    onClick={handleMuteToggle}
                    className="tw:pointer-events-auto tw:text-white hover:tw:text-gray-300 tw:transition-colors"
                >
                    {isMuted ? <VolumeX className="tw:h-5 tw:w-5" /> : <Volume2 className="tw:h-5 tw:w-5" />}
                </button>
            </div>
        </>
    )
}

export default VideoControls
